var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtHouse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 59,
    viewBox: "0 0 92 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B5E3C",
    d: "M83.304 51.159h1.39v5.218h-1.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#39B54A",
    d: "M87.024 54.371h-6.577l3.288-17.145z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M6.577 17.145H3.72v2.007h-.432V0z",
    transform: "translate(80.447 37.226)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7A9AC",
    d: "M39.443 55.675h39.213v1.367H39.443z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#131D47",
    d: "M75.309 15.722 47.93 1.497 31.536 10.35v46H75.35z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2969",
    d: "m10.46 16.413 16.11-7.87 16.134 7.88v16.875H38.37l-.786 4.112h5.119l-.022 18.94H10.46z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#524640",
    d: "M44.749 39.362h7.638v14.619h-7.638z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F341D",
    d: "M51.865 39.874v13.592H45.27V39.874z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.408 36.93v18.92h44.247L72.14 36.93z",
    transform: "translate(7.346 .5)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M77.182 37.404h1.472v16.581h-1.472zM54.33 37.404h1.473v16.589H54.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M79.502 37.41H37.585l.241-1.264.048-.256.23-1.198.049-.256.218-1.138h4.333v-2.642H76.89l.338.87.098.256.462 1.2.1.256.464 1.198.098.256.462 1.198.1.256z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M39.443 53.993h39.213v2.356H39.443z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBEC0",
    d: "M39.443 55.001h39.213v1.367H39.443z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M55.802 51.746h21.382v1.367H55.802z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M48.456 51.944h21.382v1.367H48.456z",
    transform: "translate(7.346 .5)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7F341D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.327 32.892H42.704v-1.367h34.525zM77.89 34.348H42.703v-1.367h35.085zM78.451 35.802H38.104l.049-1.366h40.2zM79.014 37.256H37.826l.048-1.366h41.04z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.339 7.004c0 .765-.632 1.383-1.408 1.383a1.396 1.396 0 0 1-1.408-1.383c0-.766.631-1.382 1.408-1.382.776 0 1.408.618 1.408 1.382z",
    fill: "#8AD2F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.93 8.77c-.992 0-1.798-.793-1.798-1.768 0-.976.808-1.768 1.799-1.768.99 0 1.8.794 1.8 1.768 0 .973-.807 1.769-1.8 1.769zm0-2.765c-.56 0-1.015.448-1.015.997 0 .548.456.998 1.016.998s1.016-.448 1.016-.998-.456-.997-1.016-.997z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    d: "m20.793 8.043-16.15 8.085H1.568l17.686-8.854zM40.956.566 24.62 9.37l1.604.801 15.3-8.246zM34.558 36.904h-1.39v16.59l1.39-.008z",
    transform: "translate(7.346 .5)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.634 48.115c-.383 0-.696-.093-.696-.21v-1.14c0-.116.313-.209.696-.209.382 0 .695.093.695.209v1.14c0 .117-.313.21-.695.21z",
    fill: "#403732"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8AD2F0",
    d: "M18.065 18.503h17.012v10.879H18.065zM18.065 39.035h17.012v10.879H18.065zM57.09 39.671h17.013V50.55H57.09zM57.048 18.503H74.06v10.879H57.048zM45.296 18.503h8.436v10.879h-8.436z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    d: "m60.12 18.003-.311.771-1.73 4.284-.314.77-1.73 4.286-.312.768h-.164l-1.972-.768-.234-.092.713-1.765.784-1.938.2-.492.31-.769 1.731-4.284.311-.77zM61.837 18.385l-.27.674-1.617 4-.311.768-1.73 4.287-.314.768H56.05l.313-.768 1.73-4.287.312-.769 1.732-4.284.311-.77h.41zM63.064 18.863l-.715 1.764-.782 1.938-.201.493-.31.77-1.732 4.286-.31.768h-.868l.31-.768 1.734-4.287.31-.769 1.067-2.638.747-1.847.518.201zM45.232 18.003l-.31.771-1.733 4.284-.311.77-.319.787-.782 1.938-.632 1.56-.311.77v.003l-.012-.004-1.97-.768-.12-.048-.245-.095.245-.607 1.43-3.537.31-.769 1.305-3.225.738-1.83zM46.386 18.106v1.678l-.783 1.94-.54 1.334-.312.77-1.732 4.286-.31.768h-1.547l.313-.768.302-.748.782-1.939.647-1.6.311-.769 1.73-4.284.312-.77h.564zM46.386 21.147v2.143l-.783 1.936-1.166 2.888-.313.768h-.866l.311-.768 1.733-4.287zM17.584 38.84l-.187.466-1.532 3.789-.782 1.938-1.46 3.612-.312.771h-1.81l-.784-.306.784-1.94 1.136-2.81.311-.77 1.733-4.284.31-.77h1.81zM21.621 38.84l-.187.466-1.733 4.284-.31.77-1.733 4.285-.31.771h-1.81l-.782-.306.188-.465.139-.343.782-1.94.81-2.001.31-.77 1.733-4.285.311-.77h1.81zM24.334 38.919l-.157.387-.42 1.036-.781 1.94-.53 1.308-.31.77-1.733 4.285-.311.771h-1.546l.313-.77 1.73-4.285.312-.77 1.73-4.285.312-.77h.411zM27.731 38.987v1.32l-.392.97-.392.97-.543 1.343-.313.77-1.73 4.285-.311.771h-.866l.311-.77.263-.654 1.468-3.631.31-.77 1.411-3.492.32-.793.177-.433zM60.22 39.406l-.216.536-1.733 4.284-.31.77-1.731 4.285-.311.769h-1.602l-.964-.376.16-.393.594-1.471.784-1.94.353-.873.311-.77 1.733-4.285.31-.77h2.024zM61.837 40.037l-.23.57-1.462 3.62-.31.77L58.1 49.28l-.31.769h-1.544l.311-.769 1.73-4.284.312-.77 1.73-4.285.174-.426 1.092.426.011.005zM64.177 39.173l-.311.769-1.474 3.646-.785 1.94-1.514 3.753-.311.769h-.867l.31-.769 1.731-4.284.311-.77.34-.844.785-1.938.606-1.503.311-.77zM66.755 39.173v.79l-.782 1.938-.94 2.325-.312.77-1.73 4.285-.312.769h-.676l-.166-.065.555-1.368 1.462-3.62.313-.77 1.73-4.285.314-.77zM66.755 41.506v2.145l-.782 1.938-1.491 3.692-.313.769h-.866l.311-.769 1.731-4.284.311-.77.317-.781zM21.58 18.003l-.31.771-1.731 4.284-.313.77-1.73 4.286-.312.768h-.608l-1.82-.71.023-.058.304-.75.782-1.938.645-1.599.313-.769 1.73-4.284.312-.77zM23.632 18.537l-.656 1.625-1.171 2.896-.313.77-1.73 4.286-.312.768h-1.545l.309-.768 1.733-4.287.31-.769 1.733-4.284.308-.76zM25.554 18.003l-.31.771-1.486 3.675-.782 1.94-1.507 3.725-.311.768h-.866l.311-.768 1.731-4.287.311-.769.33-.814.783-1.938.62-1.532.309-.77zM27.731 20.13v2.14l-.63 1.557-.154.382-1.578 3.905-.311.768h-.866l.31-.768 1.734-4.287.31-.769.401-.992.392-.969z",
    transform: "translate(7.346 .5)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m27.25 23.558-.678 1.367h.712l.679-1.367h-.712zm0 0-.678 1.367h.712l.679-1.367h-.712zm0 0-.678 1.367h.712l.679-1.367h-.712zm-9.185-5.055v10.88h17.012v-10.88H18.063h.002zm12.649.771h3.58v4.284h-3.58v-4.284zm-8.285 9.34h-3.582v-4.285h3.582v4.285zm0-5.056h-3.582v-4.284h3.582v4.284zm7.5 5.056h-6.716v-4.285h6.716v4.285zm0-5.056h-6.716v-4.284h6.716v4.284zm4.364 5.056h-3.581v-4.285h3.581v4.285zm-7.042-5.056-.679 1.367h.712l.679-1.367h-.712zm0 0-.679 1.367h.712l.679-1.367h-.712zm0 0-.679 1.367h.712l.679-1.367h-.712zm0 0-.679 1.367h.712l.679-1.367h-.712zM23.21 44.09v-.497l-.783 1.938V48.8l.784-1.938v-2.003h4.333l.31-.77h-4.643v.001zm0 0v-.497l-.783 1.938V48.8l.784-1.938v-2.003h4.333l.31-.77h-4.643v.001zm0 0v-.497l-.783 1.938V48.8l.784-1.938v-2.003h4.333l.31-.77h-4.643v.001zm-5.147-5.055v10.88h17.012v-10.88H18.063zm.784.77h3.582v4.285h-3.582v-4.284zm3.582 9.34h-3.582v-4.284h3.582v4.284zm7.5 0h-6.716v-4.284h6.716v4.284zm0-5.055h-6.716v-4.284h6.716v4.284zm4.364 5.055h-3.581v-4.284h3.581v4.284zm0-5.055h-3.581v-4.284h3.581v4.284zm-11.082 0v-.497l-.784 1.938V48.8l.784-1.938v-2.003h4.333l.31-.77h-4.643v.001zm0 0v-.497l-.784 1.938V48.8l.784-1.938v-2.003h4.333l.31-.77h-4.643v.001zm0 0v-.497l-.784 1.938V48.8l.784-1.938v-2.003h4.333l.31-.77h-4.643v.001zm0 0v-.497l-.784 1.938V48.8l.784-1.938v-2.003h4.333l.31-.77h-4.643v.001zM65.983 44.726l-.677 1.367h.715l.676-1.367h-.714zm0 0-.677 1.367h.715l.676-1.367h-.714zm0 0-.677 1.367h.715l.676-1.367h-.714zm0 0-.677 1.367h.715l.676-1.367h-.714zm0 0-.677 1.367h.715l.676-1.367h-.714zm-8.894-5.055V50.55H74.1V39.671H57.09zm5.148.77h6.716v4.285h-6.716v-4.284zm-4.364 0h3.581v4.285h-3.58v-4.284zm0 5.056h3.581v4.284h-3.58v-4.284zm11.082 4.284H62.24v-4.284h6.716v4.284zm4.364 0h-3.581v-4.284h3.58v4.284zm0-5.053h-3.581v-4.284h3.58v4.284zm-7.334 0-.677 1.367h.715l.676-1.367h-.714zm0 0-.677 1.367h.715l.676-1.367h-.714zm0 0-.677 1.367h.715l.676-1.367h-.714zm0 0-.677 1.367h.715l.676-1.367h-.714zM65.792 23.558l-.68 1.367h.713l.677-1.367h-.714.004zm0 0-.68 1.367h.713l.677-1.367h-.714.004zm0 0-.68 1.367h.713l.677-1.367h-.714.004zm-8.744-5.055v10.88h17.013v-10.88H57.048zm.785.771h3.58v4.284h-3.58v-4.284zm0 9.34v-4.285h3.58v4.285h-3.58zm11.082 0h-6.717v-4.285h6.717v4.285zm0-5.056h-6.717v-4.284h6.717v4.284zm4.363 5.056h-3.581v-4.285h3.581v4.285zm0-5.056h-3.581v-4.284h3.581v4.284zm-7.486 0-.68 1.367h.713l.677-1.367h-.714.004zm0 0-.68 1.367h.713l.677-1.367h-.714.004zM45.294 18.503v10.88h8.438v-10.88h-8.438zm.784.771h3.045v4.284h-3.045v-4.284zm3.045 9.34h-3.045v-4.285h3.045v4.285zm3.826-4.285v4.285h-3.042v-4.285h3.042zm0-.77h-3.042v-4.285h3.042v4.284z",
    fill: "#FFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M45.796 16.628H42.72L26.57 8.543l-16.147 8.085H7.346L26.57 7.004z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F341D",
    d: "M47.826.5 30.924 9.614l1.603.8 15.3-8.245 27.708 14.52h3.137z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.358 16.128v16.67l9.697.002-6.61-16.672z",
    transform: "translate(7.346 .5)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.443 37.404h1.472v16.589h-1.472z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.167 36.904h1.391v16.589h-1.391zM70.908 36.901h1.391V53.49h-1.391zM48.055 36.904h1.391v16.589h-1.391z",
    transform: "translate(7.346 .5)"
  }), /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#8B5E3C",
    d: "M5.81 52.518h1.391v3.935H5.81z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 47.46c0 2.974-2.342 5.412-5.314 5.63h-.004c-.141.01-.284.015-.427.015H6.24c-.143 0-.286-.006-.427-.015H5.81C2.84 52.87.5 50.434.5 47.46c0-2.975 2.57-5.644 5.741-5.646h.004c3.174 0 5.745 2.529 5.745 5.646z",
    fill: "#39B54A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.49 5.645c0 2.975-2.342 5.412-5.314 5.63h-.004v3.366H5.74V0h.004c3.174 0 5.745 2.529 5.745 5.645z",
    fill: "#000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(.5 41.814)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#39B54A",
    d: "M.975 56.401H91.5v1.367H.975z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#009245",
    d: "M.975 57.133H91.5V58.5H.975z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-house.8a852a11d2f5f6d41b0ab4e843760c58.svg";